import 'slick-carousel'
import 'slick-lightbox'
import '@js/custom/parallaxie'
import Plyr from 'plyr'
import Cookies from 'js-cookie'
import moment from 'moment'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import TextPlugin from 'gsap/TextPlugin'

const facebook = ''
const instagram = ''

const digistormWeb = {
    init() {
        // helper for iOS issues
        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        // this.wowo()
        this.nav()
        this.tabs()
        this.accordions()
        this.videos.init()
        this.gallery()
        this.imageSlick()
        this.video_modal()
        this.forms()
        this.popups()
        this.analytics()
        this.employment()
        this.newsletters()
        this.entryScreen()
        // this.socialFeeds();
        this.newsletterBackToTop()
        this.stickyMenu()
        this.navbar()
        // this.entryCalculator()
        this.userback()
    },
    widgetLock() {
        $('html').css('overflow', 'hidden')
    },
    widgetUnlock() {
        $('html').css('overflow', '')
    },
    customSlickArrow(_self, loop = true) {
        const $controlwrapper = _self.next('.slick-bottom')
        const slickLength = _self.find('.item').length
        _self.on('init', (slick) => {
            if (slickLength > 1) {
                $controlwrapper.find('.slick-arrow').show()
            }
            $controlwrapper.find('.slick-prev:not(.slick-disabled)').on('click', () => {
                _self.slick('slickPrev')
            })
            $controlwrapper.find('.slick-next:not(.slick-disabled)').on('click', () => {
                _self.slick('slickNext')
            })
        })

        if (!loop) {
            $controlwrapper.find('.slick-prev').addClass('slick-disabled')
            _self.addClass('unloop')
            _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                const trueSlideCount = _self.next('.slick-bottom').find('.slick-dots').find('li').length
                const slideCount = trueSlideCount || slick.slideCount
                if (nextSlide === 0) {
                    $controlwrapper.find('.slick-prev').addClass('slick-disabled')
                } else {
                    $controlwrapper.find('.slick-prev').removeClass('slick-disabled')
                }
                if (nextSlide === slideCount - 1) {
                    $controlwrapper.find('.slick-next').addClass('slick-disabled')
                } else {
                    $controlwrapper.find('.slick-next').removeClass('slick-disabled')
                }

                $controlwrapper.find('.slick-prev:not(.slick-disabled)').on('click', () => {
                    _self.slick('slickPrev')
                })
                $controlwrapper.find('.slick-next:not(.slick-disabled)').on('click', () => {
                    _self.slick('slickNext')
                })
            })
        }
    },
    nav() {
        $('.parent-item .parent-title').bind(' mouseenter ', function (e) {
            if ($(window).width() > 1023) {
                e.preventDefault()
                const parent = $(this).closest('.parent-item')
                const index = parent.index() + 1
                parent.addClass('is-active').siblings('.parent-item').removeClass('is-active')
                $('.offcanvas-navbar-images .img').eq(index).addClass('is-active').siblings()
                    .removeClass('is-active')
            }
        })
        $('.level1').bind(' focus mouseenter keydown', function (e) {
            if ($(window).width() > 1023) {
                $(this).addClass('is-active')
            }
        })
        $('.level1').on('mouseleave', function () {
            if ($(window).width() > 1023) {
                $(this).removeClass('is-active')
            }
        })
        $('.parent-item.has-child .parent-wrapper').on('click', function () {
            const parent = $(this).closest('.parent-item')
            const index = parent.index() + 1

            if ($(window).width() <= 1023) {
                parent.toggleClass('is-active').siblings('.parent-item').removeClass('is-active')

                $('.offcanvas-navbar-images .img')
                    .eq(index)
                    .toggleClass('is-active')
                    .siblings()
                    .removeClass('is-active')
            }
        })

        $('.child-item.has-third .child-title').after('<span class="view-third"></span>')
        $('.child-item.has-third').on('click', '.view-third', function (e) {
            const parent = $(this).parents('.child-item.has-third')
            const dropdown = parent.find('.third-panel')
            parent.toggleClass('is-active').siblings('.child-item').removeClass('is-active')
            $('.level2').toggleClass('is-active')
        })

        $('.level3 a').on('click', (e) => {
            e.stopPropagation()
        })
    },
    tabs() {
        $('.tabs')
            .find('.tabs-title')
            .click(function () {
                const $tabs = $(this).closest('.tabs')
                const activeIndex = $(this).index()

                $tabs.find('.tabs-title').removeClass('is-active')
                $tabs.find('.tabs-content').removeClass('is-active')

                $(this).addClass('is-active')
                $tabs.find('.tabs-content').eq(activeIndex).addClass('is-active')
            })
    },
    accordions() {
        $('.accordion')
            .find('.accordion-header')
            .on('click', function () {
                const $wrapper = $(this).closest('.accordion-wrapper')
                const $content = $(this).next('.accordion-content')
                const $wasActive = $wrapper.hasClass('is-active')
                const $otherWrapper = $wrapper.siblings()
                if ($wasActive) {
                    $wrapper.removeClass('is-active')
                    $content.stop().slideUp(250)
                } else {
                    $wrapper.addClass('is-active')
                    $content.stop().slideDown(250)
                    $otherWrapper.removeClass('is-active').find('.accordion-content').slideUp(250)
                }
            })
    },
    videos: {
        init() {
            const _self = this

            // check if there is a video player wrapper

            if ($('.video-player.banner-video').length) {
                $('.video-player.banner-video').each(function () {
                    _self.loadVideo(this)
                })
            }

            _self.controls()
            _self.carousel()
        },
        controls() {
            // initialise video controls

            $('.video-carousel .banner .control-pause').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.togglePlay($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-play').addClass('fa-pause')
                        break
                    case false:
                        $(this).removeClass('fa-pause').addClass('fa-play')
                        break
                }
            })

            $('.video-carousel .banner .control-vol').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.toggleMute($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-volume-off').addClass('fa-volume-up')
                        break
                    case false:
                        $(this).removeClass('fa-volume-up').addClass('fa-volume-off')
                        break
                }
            })
        },
        carousel() {
            // handle videos inside slick carousels
            $('.video-carousel')
                .on('init', (event, slick) => {
                    // mark carousel as initialized
                    slick.is_initialized = true
                })
                .on('setPosition', (event, slick) => {
                    // synchronize slides with videos

                    if (slick.is_initialized) {
                        // the slide up next
                        const $newSlide = $(slick.$slides[slick.currentSlide])

                        // pause others
                        $newSlide
                            .closest('.video-carousel')
                            .find('.banner')
                            .not($newSlide)
                            .find('.video-player')
                            .each((i, e) => {
                                if (digistormWeb.iOS) {
                                    // currently there's a bug with plyr where pause won't work on iOS
                                    digistormWeb.videos.stopVideo($(e))
                                } else {
                                    digistormWeb.videos.pauseVideo($(e))
                                }
                            })

                        // play new slide
                        const video = $newSlide.find('.video-player')
                        digistormWeb.videos.playVideo(video)
                        if (video.data() && video.data().player) {
                            // This slide is a video, pause slick autoslide
                            slick.$slider.slick('slickPause')
                        } else {
                            // This slide is not a video, resume slick autoslide
                            slick.$slider.slick('slickPlay')
                            $('.circleProgress').css('animation-duration', `${5.9}s`)
                        }
                    }
                })
        },
        loadVideo(el) {
            // load a video element

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')

            const plyr = new Plyr(player[0], settings)
            console.log(plyr);
            
            // set up each video
            $(el).data({
                player: plyr,
            })

            // if a carousel video, go to the next slide on video end
            const $carousel = $(el).closest('.video-carousel')
            if ($carousel.length) {
                if (plyr.source && plyr.source.indexOf('youtube') >= 0) {
                    // youtube loop doesn't work, manually detect end of video
                    plyr.on('timeupdate', (event) => {
                        if (plyr.currentTime >= plyr.duration - 0.1) {
                            plyr.restart()
                            if ($carousel.find('.banner').length > 1) {
                                $carousel.slick('slickNext')
                            }
                        }
                    })
                } else {
                    // on loop, go to the next slide
                    plyr.on('seeked', (event) => {
                        $carousel.slick('slickNext')
                    })
                }

                plyr.on('playing', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play')
                        .addClass('fa-pause')
                })
                plyr.on('pause', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play')
                        .addClass('fa-pause')
                })
            }

            if (settings.muted && settings.autoplay) {
                digistormWeb.videos.attemptPlay(plyr)
            }
        },
        loadVideoModal(el) {
            // console.log("loading video now");

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')

            const plyr = new Plyr(player[0], settings)

            // set up each video
            $(el).data({
                player: plyr,
            })

            digistormWeb.videos.attemptPlay(plyr, settings.volume, settings.muted)

            $(el).addClass('plyr-loaded')
        },
        
        checkBuffered(player, isBuffered, intervalId) {
            if (isBuffered) return
            const buffered = player.buffered

            if (buffered > 0 && player.currentTime > 0) {
                $(player.elements.container).prev('.video-poster').fadeOut()
                isBuffered = true
                clearInterval(intervalId)
            }
        },

        attemptPlay(player, volume = 0, muted = true, count = 0) {
            // attempts to play the video multiple times in case element is still loading

            player.volume = volume
            player.muted = muted
            player.play()

            if (player.playing) {
                const isBuffered = false
                const intervalId = setInterval(() => {
                    digistormWeb.videos.checkBuffered(player, isBuffered, intervalId)
                }, 500)
            }

            if (count < 15 && !player.playing) {
                setTimeout(() => {
                    count++
                    digistormWeb.videos.attemptPlay(player, volume, muted, count)
                }, 1000)
            }
        },
        playVideo($el, volume = 0, muted = 1) {
            if ($el.data() && $el.data().player) {
                // enable ability to play unmuted
                $el.data().player.volume = volume
                $el.data().player.muted = muted
                $el.data().player.play()
            }
        },
        pauseVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.pause()
            }
        },
        stopVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.stop()
            }
        },
        togglePlay($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.togglePlay()
                return $el.data().player.playing
            }
            return 'no-data'
        },
        toggleMute($el) {
            if ($el.data() && $el.data().player) {
                const player = $el.data().player
                if (player.volume === 0) {
                    player.volume = 1
                    return true
                }
                player.volume = 0
                return false
            }
            return 'no-data'
        },
    },
    gallery() {
        const galleryLightbox = $('.gallery')
            .find('ul')
            .slickLightbox({
                itemSelector: '> li > a',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<button class="close-modal slick-lightbox-close close-button"> <span></span> <span></span> <span></span> </button>',
                },
            })
        galleryLightbox.on({
            'show.slickLightbox': function () {
                digistormWeb.lockBg()
                digistormWeb.widgetLock()
            },
            'shown.slickLightbox': function () {
                // fired when the lightbox is opened, after the transitions took place
            },
            'hide.slickLightbox': function () {
                // fired when the lightbox is closed
                digistormWeb.unlockBg()
                digistormWeb.widgetUnlock()
            },
            'hidden.slickLightbox': function () {
                // fired when the lightbox is closed, after the transitions took place
            },
        })

        $('.gallery .more-s').click(function (e) {
            e.preventDefault()
            $(this).closest('.gallery').find('.is-hidden:first a').click()
        })
    },
    imageSlick() {
        $('.image-slick .slick').each(function () {
            const _self = $(this)
            const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length

            digistormWeb.customSlickArrow(_self, false)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotsWrapper,
                arrows: false,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
            })
        })

        // lightbox config
        $('.image-slick')
            .find('.slick')
            .slickLightbox({
                src: 'src',
                itemSelector: 'img',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<button class="close-modal slick-lightbox-close close-button"> <span></span> <span></span> <span></span> </button>',
                },
            })
    },
    video_modal() {
        $('.open-video-modal').on('click', function (e) {
            e.preventDefault()
            const modalId = $(this).attr('data-modal-id')
            const modal = $(`#${modalId}`)

            if (!modal) {
                return
            }

            const videoPlayer = modal.find('.video-player')
            if (!videoPlayer) {
                return
            }

            if (!videoPlayer.hasClass('plyr-loaded')) {
                digistormWeb.videos.loadVideoModal(videoPlayer[0])
            } else {
                const settings = JSON.parse(videoPlayer.attr('data-settings'))
                digistormWeb.videos.playVideo(videoPlayer, settings.volume, settings.muted)
            }

            modal.addClass('is-active')
        })

        $('.video-modal .modal-background').click(function () {
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            if (digistormWeb.iOS) {
                digistormWeb.videos.stopVideo($modal.find('.video-player'))
            } else {
                digistormWeb.videos.pauseVideo($modal.find('.video-player'))
            }
        })

        $('.video-modal .close-button').click(function (e) {
            e.preventDefault()
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            digistormWeb.videos.stopVideo($modal.find('.video-player'))
        })
    },
    forms() {
        // Send google analytics event on form submission
        $('[data-form-name] form').submit(function () {
            const formWrapper = $(this).closest('[data-form-name]')
            if (window.ga) {
                ga('send', 'event', formWrapper.attr('data-form-name'), formWrapper.attr('data-form-page'))
            }
        })
    },
    popups() {
        $('.action-modal').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active').removeClass('delete')
                $('#ds-vue-wrapper').addClass('action-modal-active')

                modal.find('.close-action-modal,.action-modal-background').click(() => {
                    modal.addClass('delete').removeClass('active')
                    $('#ds-vue-wrapper').removeClass('action-modal-active')
                    Cookies.set(key, 'viewed', {
                        expires: 5,
                    })
                })
            }
        })
    },
    analytics() {
        // Track clicks on external links
        $('body').on('click', 'a[href]', function (e) {
            const domain = String(window.location.host).replace(/^www\./, '')
            const openInNewWindow = $(this).attr('target') === '_blank'
            const url = $(this).attr('href')

            // Find the domain of the link. Works with http, https and protocol-less urls
            const linkAnatomy = url.match(/^(https?:)?\/\/(www\.)?([^/\s]+)/)
            if (linkAnatomy) {
                const linkDomain = linkAnatomy[3]

                // Check if google analytics is loaded and the url is external
                if (window.ga && domain !== linkDomain) {
                    ga('send', 'event', 'Navigation', 'Open URL', url)

                    // If the link will open in this window we should delay navigation until the event is sent
                    if (!openInNewWindow && !e.isDefaultPrevented()) {
                        e.preventDefault()

                        // Push the navigation onto the queue (will be processed after event is sent)
                        ga(() => {
                            // Navigate to url
                            window.location.href = url
                        })

                        return false
                    }
                }
            }
        })
    },
    employment() {
        $('.application-form').each((i, e) => {
            const $form = $(e)
            const jobTitle = $form.data('job-title')
            $form.find('input.positionAppliedFor').val(jobTitle)
        })
    },
    newsletters() {
        // Newsletter section
        $('.newsletter-article')
            .find('.continue')
            .on('click', function (e) {
                const $article = $(this).parent()
                const $expandable = $article.find('.newsletter-blocks-wrapper')
                const $content = $article.find('.newsletter-blocks')

                // toggle class
                $article.toggleClass('is-active')

                // set height to article size
                const height = $content.outerHeight() + 20
                $expandable.css({
                    'max-height': `${height}px`,
                })

                if ($article.hasClass('is-active')) {
                    // allow any height after animation done
                    setTimeout(() => {
                        if ($article.hasClass('is-active')) {
                            $expandable.css({
                                'max-height': 'none',
                            })
                        }
                    }, 300)
                } else {
                    // if collapsing article set max height
                    setTimeout(() => {
                        if (!$article.hasClass('is-active')) {
                            $expandable.css({
                                'max-height': '0',
                            })
                        }
                    }, 100)
                }
            })

        $('.newsletter-sidebar #newsletter-menu').on('click', function (e) {
            if ($(window).width() < 1023) {
                const menuparent = $(this).closest('.newsletter-sidebar')
                $('.newsletter-categories').stop().slideToggle()

                if (!menuparent.hasClass('is-active')) {
                    menuparent.addClass('is-active')
                } else {
                    menuparent.removeClass('is-active')
                }
            }
        })

        $('.newsletter-sidebar .category-heading').click(function () {
            const target = $($(this).attr('data-attr'))

            const windowWidth = $(window).width()
            if (windowWidth < 1023) {
                const menuparent = $(this).closest('.newsletter-sidebar')
                $('.toggle-nav-newsletter').toggleClass('cross')
                $('.newsletter-sidebar').toggleClass('open-sidenav')
                $('.newsletter-categories').slideUp(300)
                menuparent.removeClass('is-active')
                const scrollTop = $(window).scrollTop()
                if (scrollTop > target.offset().top) {
                    setTimeout(() => {
                        $('html, body').animate(
                            {
                                scrollTop: target.offset().top - 144,
                            },
                            800,
                        )
                    }, 300)
                } else {
                    setTimeout(() => {
                        $('html, body').animate(
                            {
                                scrollTop: target.offset().top - 58,
                            },
                            800,
                        )
                    }, 300)
                }
            } else {
                $('html, body').animate(
                    {
                        scrollTop: target.offset().top - 200,
                    },
                    800,
                )
            }
        })
    },
    entryScreen() {
        const es = $('.entry-screen')
        const btn = $('.entry-screen #entry-screen-btn')
        const key = 'entryScreen'

        const cookie = Cookies.get(key)

        if (!cookie) {
            es.addClass('active')
            btn.on('click', () => {
                Cookies.set(key, 'viewed', {
                    expires: 1,
                })

                es.removeClass('active')
            })
        }
    },
    socialFeeds() {
        $('section.social-block').each(function () {
            // console.log("requesting social posts...");
            const socialWrapper = $(this).find('.social-wrapper')
            //   this is the toggle for individual social blocks
            const facebookToggle = $(this).attr('data-facebook') === '1'
            const instagramToggle = $(this).attr('data-instagram') === '1'
            const limit = 18

            const svgMap = {
                facebook,
                instagram,
            }

            $.ajax({
                url: '/api/socialfeed/request-posts',
                data: {
                    facebook: facebookToggle,
                    instagram: instagramToggle,
                    limit,
                },
                dataType: 'json',
                success(posts) {
                    let postHtml = ''
                    $.each(posts, (index, post) => {
                        const postDescription
                            = post.description.length > 200
                                ? `${post.description.substring(0, 199).trim()}...`
                                : post.description
                        const date = new Date(post.created * 1000).toLocaleDateString()

                        let iconSvg = ''
                        if (post.type in svgMap) {
                            iconSvg = svgMap[post.type]
                        }

                        const html = `<a href="${post.link}" class="item card-overlay" target="_blank"><div class="img"><div class="responsive-img"><img src="${post.image}" alt="" /></div></div><div class="overlay"><div class="lower"><div class="text"><span class="social-icon">${iconSvg}</span><p>${postDescription}</p></div></div></div></a>`

                        postHtml += html
                    })

                    // render posts on page
                    socialWrapper.html(postHtml)
                },
            }).fail(() => {
                console.log('...failed fetching social posts')
                socialWrapper
                    .find('.socials-loading')
                    .html('<h5>Something went wrong when fetching social feed.<br>Please try again later!</h5>')
            })
        })
    },
    newsletterBackToTop() {
        $('.back-top').on('click', () => {
            $('body')[0].scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            })
        })
    },
    entryCalculator() {
        function calculateEnrol(birthYear, birthMonth) {
            // QLD kids start Pre prep at 4 years old, so add 4 to the year they were born
            let startYear = birthYear + 4
            const yearLevels = [
                'Pre Prep',
                'Prep',
                'Year 1',
                'Year 2',
                'Year 3',
                'Year 4',
                'Year 5',
                'Year 6',
                'Year 7',
                'Year 8',
                'Year 9',
                'Year 10',
                'Year 11',
                'Year 12',
            ]
            // students born after june get pushed forward a year
            if (birthMonth > 6) {
                startYear++
            }
            const $resultsContainer = $('.child-results')
            const $resultsTable = $resultsContainer.find('table')
            let resultsHtml = '<tr><th>Year of Entry</th><th>Year</th></tr>'
            for (let i = 0; i < yearLevels.length; i++) {
                if (
                    yearLevels[i] === 'Pre Prep'
                    || yearLevels[i] === 'Year 4'
                    || yearLevels[i] === 'Year 7'
                    || yearLevels[i] === 'Year 10'
                ) {
                    resultsHtml = `${resultsHtml}<tr><td>${startYear}</td><td>${yearLevels[i]}</td>`
                }
                startYear++
            }
            // clear table and render results
            $resultsContainer.show()
            $resultsTable.html('').append(resultsHtml)
        }
        // init datepicker
        const $datepicker = $('.input-group.date')
        $datepicker.datepicker({
            container: '.picker-container',
            startDate: `01/01/${new Date().getFullYear() - 15}`,
            startView: '2',
            autoclose: true,
            todayHighlight: true,
            format: 'dd/mm/yyyy',
        })
        // listen for datepicker change
        $datepicker.datepicker().on('changeDate', (e) => {
            const childBirthday = moment($datepicker.datepicker('getDate'))
            calculateEnrol(childBirthday.year(), childBirthday.month() + 1)
        })
    },
    stickyMenu() {
        if ($('.navigation').length) {
            const { body } = document
            const nav = document.querySelector('.navigation')
            const scrollUp = 'menu-stuck'
            const scrollUpNav = 'is-stuck'
            const scrollDown = 'scroll-down'
            let lastScroll = 0

            let width = $(document).width()
            let navOffset = 90

            window.addEventListener('resize', () => {
                width = $(window).width()
            })

            window.addEventListener('scroll', () => {
                const currentScroll = window.pageYOffset
                const scrollLimit = 0
                const scrollValue = window.scrollY

                if ($('body').hasClass('autoscroll')) {
                    return
                }

                if (width <= 1023) {
                    navOffset = 90
                } else if (width < 1215) {
                    navOffset = 90
                } else {
                    navOffset = 90
                }

                // console.log({scrollValue, lastScroll, width, currentScroll, navOffset})

                if (scrollValue >= scrollLimit) {
                    if (currentScroll <= navOffset) {
                        body.classList.remove(scrollUp)
                        body.classList.remove(scrollDown)
                        nav.classList.remove(scrollUpNav)
                        return
                    }
                    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                        // down
                        body.classList.remove(scrollUp)
                        nav.classList.remove(scrollUpNav)
                        body.classList.add(scrollDown)
                    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                        // up
                        body.classList.remove(scrollDown)
                        body.classList.add(scrollUp)
                        nav.classList.add(scrollUpNav)
                    }
                    lastScroll = currentScroll
                }
            })
        }
    },
    navbar() {
        $('.navigation')
            .find('.navbar-burger')
            .on('click', function (e) {
                e.preventDefault()
                const target = $(this).attr('data-target')
                const targetObj = $(`#${target}`)
                const object = $('body')
                if (!object.hasClass('menu-open')) {
                    $(object).addClass('menu-open')
                    targetObj.addClass('is-active')
                } else {
                    $(object).removeClass('menu-open')
                    targetObj.removeClass('is-active')
                }
            })
    },
    lockBg() {
        // lock window position
        document.documentElement.style.overflow = 'hidden'
        document.body.scroll = 'no'
    },
    unlockBg() {
        // unlock window position
        document.documentElement.style.overflow = 'scroll'
        document.body.scroll = 'yes'
    },
    lockScroll() {
        const htmlElement = document.documentElement
        const bodyElement = document.body
        const initWidth = bodyElement.offsetWidth
        const initHeight = bodyElement.offsetHeight

        const scrollPosition = [
            window.pageXOffset || htmlElement.scrollLeft || bodyElement.scrollLeft,
            window.pageYOffset || htmlElement.scrollTop || bodyElement.scrollTop,
        ]
        htmlElement.dataset.scrollPosition = JSON.stringify(scrollPosition)
        htmlElement.dataset.previousOverflow = htmlElement.style.overflow

        htmlElement.style.overflow = 'hidden'
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        const marginR = bodyElement.offsetWidth - initWidth
        const marginB = bodyElement.offsetHeight - initHeight
        bodyElement.style.marginRight = `${marginR}px`
        bodyElement.style.marginBottom = `${marginB}px`
    },
    unlockScroll() {
        const $html = $('html')
        const $body = $('body')
        $html.css('overflow', $html.data('previous-overflow'))
        const scrollPosition = $html.data('scroll-position')
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        $body.css({
            'margin-right': 0,
            'margin-bottom': 0,
        })
    },
    userback() {
        window.Userback = window.Userback || {}
        Userback.access_token = 'P-EgZglIFiRQnCROOgBuViCpLlm';
        (function (d) {
            const s = d.createElement('script')
            s.async = true
            s.src = 'https://static.userback.io/widget/v1.js';
            (d.head || d.body).appendChild(s)
        }(document))
    },
}

const customWeb = {
    init() {
        this.widgetCategoriesNav()
        this.customSlick()
        this.customDropdown()
        this.customClick()
        this.customResize()
        this.customTabindexLoop()
        this.customModalOpen()
        this.customAlertBar()
        this.customParallx()
        this.customScroll()
        this.customLinkCircle()
        this.customGasp()
        this.customNewsBack()
        this.wowo()
    },
    widgetCategoriesNav() {
        const _con = $('.categories-nav')
        _con.find('p').on('click', function () {
            $(this).next().stop().slideToggle(250)
            $(this).parents('.categories-nav').toggleClass('is-active')
        })
        _con.find('li').on('click', function () {
            const me = $(this)
            me.parents('.categories-nav').removeClass('is-active').find('p').html(me.text())
            me.parents('ul').stop().slideToggle(250)
            me.addClass('is-active').siblings().removeClass('is-active')
        })
        $('body').on('click', (e) => {
            if (!_con.is(e.target) && _con.has(e.target).length === 0) {
                _con.find('ul').stop().slideUp(250)
                _con.removeClass('is-active')
            }
        })
    },
    customSlickArrow(_self, loop = true) {
        const $controlwrapper = _self.next('.slick-bottom')
        const slickLength = _self.find('.item').length
        let slideCount = _self.next('.slick-bottom').find('.slick-dots').find('li').length

        $(window).on('resize', () => {
            slideCount = _self.next('.slick-bottom').find('.slick-dots').find('li').length
        })

        _self.on('init', (slick) => {
            if (slickLength > slideCount) {
                $controlwrapper.find('.slick-arrow').show()
            }
            $controlwrapper.find('.slick-prev:not(.slick-disabled)').on('click', () => {
                _self.slick('slickPrev')
            })
            $controlwrapper.find('.slick-next:not(.slick-disabled)').on('click', () => {
                _self.slick('slickNext')
            })
        })

        if (!loop) {
            $controlwrapper.find('.slick-prev').addClass('slick-disabled')
            _self.addClass('unloop')
            _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                const trueSlideCount = _self.next('.slick-bottom').find('.slick-dots').find('li').length
                const slideCount = trueSlideCount || slick.slideCount
                if (nextSlide === 0) {
                    $controlwrapper.find('.slick-prev').addClass('slick-disabled')
                } else {
                    $controlwrapper.find('.slick-prev').removeClass('slick-disabled')
                }
                if (nextSlide === slideCount - 1) {
                    $controlwrapper.find('.slick-next').addClass('slick-disabled')
                } else {
                    $controlwrapper.find('.slick-next').removeClass('slick-disabled')
                }

                $controlwrapper.find('.slick-prev:not(.slick-disabled)').on('click', () => {
                    _self.slick('slickPrev')
                })
                $controlwrapper.find('.slick-next:not(.slick-disabled)').on('click', () => {
                    _self.slick('slickNext')
                })
            })
        }
    },
    customSlickProgress(_self, progress = _self.next('.slick-bottom')) {
        let slideCount = _self.next('.slick-bottom').find('.slick-dots').find('li').length
        if (slideCount === 0) {
            _self.addClass('not-slick')
        } else {
            _self.removeClass('not-slick')
        }

        $(window).on('resize', () => {
            slideCount = _self.next('.slick-bottom').find('.slick-dots').find('li').length
            if (slideCount === 0) {
                _self.addClass('not-slick')
            } else {
                _self.removeClass('not-slick')
            }
        })

        progress.attr('style', `--index:1;--count:${slideCount};`)
        _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            slideCount = _self.next('.slick-bottom').find('.slick-dots').find('li').length
            const newIndex = nextSlide >= slideCount ? 1 : nextSlide + 1
            progress.attr('style', `--index:${newIndex};--count:${slideCount};`)
        })
    },
    customSlickPageNav(_self) {
        const slickProgress = _self.next('.slick-bottom').find('.slick-custom-pagination')
        const totalSlides = _self.slick('getSlick').slideCount
        // slickProgress.find(".total-pages").text("0" + totalSlides);
        slickProgress.find('.total-pages').text(`/${totalSlides}`)
        _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const currentPage = nextSlide + 1
            // slickProgress.find(".current-page").text(currentPage < 10 ? "0" + currentPage : currentPage);
            slickProgress.find('.current-page').text(currentPage)
        })
    },
    customSlickCloneActive(_self) {
        _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const totalSlides = slick.slideCount
            const $cloneSlides = _self.find('.slick-slide.slick-cloned')
            const cloneIndex = nextSlide + totalSlides

            $cloneSlides.removeClass('slick-clone-current')

            $cloneSlides.each(function () {
                if ($(this).data('slick-index') === cloneIndex) {
                    $(this).addClass('slick-clone-current')
                }
            })

            if (nextSlide === totalSlides - 1) {
                _self.find('.slick-slide[data-slick-index="-1"]').addClass('slick-clone-current')
            }
        })
    },
    customSlickHasProgress(_self, loop = true) {
        const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
        const slickLength = _self.find('.item').length
        customWeb.customSlickArrow(_self, loop)

        _self.slick({
            dots: slickLength > 1,
            appendDots: $dotsWrapper,
            arrows: false,
            infinite: loop,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            adaptiveHeight: false,
            fade: false,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            focusOnSelect: true,
            draggable: true,
            touchMove: true,
        })

        customWeb.customSlickCloneActive(_self)
        customWeb.customSlickPageNav(_self)
        customWeb.customSlickProgress(_self)
    },
    customSlickHasPagenav(_self, loop = true) {
        const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
        const slickLength = _self.find('.item').length
        customWeb.customSlickArrow(_self, loop)

        _self.slick({
            dots: slickLength > 1,
            appendDots: $dotsWrapper,
            arrows: false,
            infinite: loop,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            adaptiveHeight: false,
            fade: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            focusOnSelect: true,
            draggable: true,
            touchMove: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        adaptiveHeight: true,
                    },
                },
            ],
        })

        customWeb.customSlickCloneActive(_self)
        customWeb.customSlickPageNav(_self)
    },
    customSlick() {
        // has progress
        customWeb.customSlickHasProgress($('.image-carousel .slick'))
        customWeb.customSlickHasProgress($('.learning .slick'))

        // has pagenav
        customWeb.customSlickHasPagenav($('.image-textbox-carousel .slick'))
        customWeb.customSlickHasPagenav($('.quote-slick .slick'))

        $('.banner--has-slick .slick').each(function () {
            const _self = $(this)
            const loop = false
            const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self, loop)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotsWrapper,
                arrows: false,
                infinite: loop,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                adaptiveHeight: false,
                fade: true,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                touchMove: true,
            })

            customWeb.customSlickCloneActive(_self)
            customWeb.customSlickPageNav(_self)
        })

        $('.happening .left .slick').each(function () {
            const _self = $(this)
            const loop = false
            const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self, loop)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotsWrapper,
                arrows: false,
                infinite: loop,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                adaptiveHeight: false,
                fade: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                touchMove: true,
            })

            customWeb.customSlickCloneActive(_self)
            customWeb.customSlickPageNav(_self)
            customWeb.customSlickProgress(_self)
        })

        $('.community .slick').each(function () {
            const _self = $(this)
            const loop = false
            const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self, loop)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotsWrapper,
                arrows: false,
                infinite: loop,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: true,
                touchMove: true,
                // verticalSwiping: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
            customWeb.customSlickPageNav(_self)
            customWeb.customSlickProgress(_self)
        })

        $('.slick-images').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        asNavFor: '.slick-text',
                    },
                },
            ],
        })
        customWeb.customSlickCloneActive($('.slick-images'))

        $('.slick-text').each(function () {
            const _self = $(this)
            const loop = false
            const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self, loop)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotsWrapper,
                arrows: false,
                infinite: loop,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                touchMove: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            infinite: true,
                            asNavFor: '.slick-images',
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
            customWeb.customSlickPageNav(_self)
            customWeb.customSlickProgress(_self)

            _self.find('.slick-slide').on('click', function () {
                const index = $(this).index()
                if ($(window).width() > 767) {
                    $('.slick-images').slick('slickGoTo', index, false)
                }
            })

            _self
                .next('.slick-bottom')
                .find('.slick-arrow.slick-prev')
                .on('click', function () {
                    if ($(window).width() > 767 && !$(this).hasClass('slick-disabled')) {
                        const index = parseInt(_self.find('.slick-current').index(), 10) - 1
                        $('.slick-images').slick('slickGoTo', index, false)
                    }
                })

            _self
                .next('.slick-bottom')
                .find('.slick-arrow.slick-next:not(.slick-disabled)')
                .on('click', () => {
                    if ($(window).width() > 767) {
                        const index = parseInt(_self.find('.slick-current').index(), 10)
                        $('.slick-images').slick('slickGoTo', index, false)
                    }
                })
        })

        $('.social-block .slick').each(function () {
            const _self = $(this)
            const loop = true
            const $dotsWrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self, loop)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotsWrapper,
                arrows: false,
                infinite: loop,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: true,
                touchMove: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
            customWeb.customSlickPageNav(_self)
            customWeb.customSlickProgress(_self)
        })
    },
    wowo() {
        $('html').addClass('show-c')
        const wTop = $(window).scrollTop()
        const wHeight = $(window).height()
        const wBottom = wTop + wHeight
        $('.wowo:not(.animated)').each(function () {
            const me = $(this)
            const meTop = me.offset().top
            const meHeight = me.innerHeight()
            const meBottom = meTop + meHeight
            const limitTop = wTop - meHeight
            const limitBottom = wBottom + meHeight
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass('animated')
                setTimeout(() => {
                    me.removeClass('wowo')
                }, 3000)
            }
        })
    },
    customGasp() {
        gsap.registerPlugin(ScrollTrigger, TextPlugin)

        if ($('.banner--home').length) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '.banner--home',
                    start: 'top top',
                    end: '+=100%',
                    pin: true,
                    pinSpacing: true,
                    scrub: true,
                    immediateRender: false,
                },
            })

            gsap.set(['.anim-left', '.anim-right', '.scroll-box'], {
                xPercent: 0,
                opacity: 1,
            })

            gsap.set(['#happening'], {
                xPercent: 0,
            })

            tl.fromTo(
                '.anim-left',
                {
                    xPercent: 0,
                },
                {
                    xPercent: -100,
                    ease: 'sine.out',
                },
                0,
            )
                .fromTo(
                    '.scroll-box',
                    {
                        xPercent: 0,
                    },
                    {
                        xPercent: -100,
                        ease: 'sine.out',
                    },
                    0,
                )
                .fromTo(
                    '.anim-right',
                    {
                        xPercent: 0,
                    },
                    {
                        xPercent: 100,
                        ease: 'sine.out',
                    },
                    0,
                )
                .fromTo(
                    '#happening',
                    {
                        xPercent: 0,
                    },
                    {
                        xPercent: -100,
                        ease: 'sine.out',
                    },
                    0,
                )
        }

        if ($('.learning .items').length > 0) {
            const sections = gsap.utils.toArray('.learning .items .item')
            const container = document.querySelector('.learning .items')
            const totalWidth = sections.reduce((acc, item) => acc + item.offsetWidth, 0)

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '.learning',
                    start: 'top top',
                    end: () => `+=${container.scrollWidth}`,
                    pin: true,
                    pinSpacing: true,
                    scrub: true,
                    immediateRender: false,
                },
            })

            gsap.set(sections, {
                x: 0,
            })
            gsap.set('.learning .text-intro', {
                opacity: 1,
                zIndex: 1,
            })

            tl.to(
                sections,
                {
                    x: () => -(totalWidth - 0),
                    ease: 'none',
                },
                0,
            ).to(
                '.learning .text-intro',
                {
                    opacity: 0.2,
                    zIndex: 0,
                    ease: 'expo.out',
                },
                0,
            )
        }

        $('.homepage .text-intro h2').each(function () {
            const $this = $(this)
            const $spans = $this.find('span')

            if ($spans.length) {
                $spans.each(function (index) {
                    const $span = $(this)
                    const text = $span.text().trim()

                    const wrappedText = text
                        .split(' ')
                        .map((word) => {
                            return `<span class="outer-span"><span>${word}</span></span>`
                        })
                        .join(' ')

                    $span.html(wrappedText)

                    if (index < $spans.length - 1) {
                        $span.after(document.createTextNode(' '))
                    }
                })
            } else {
                const text = $this.text().trim()

                const wrappedText = text
                    .split(' ')
                    .map((word) => {
                        return `<span class="outer-span"><span>${word}</span></span>`
                    })
                    .join(' ')

                $this.html(wrappedText)
            }

            gsap.from($this.find('.outer-span span'), {
                yPercent: 100,
                opacity: 0,
                stagger: 0.2,
                duration: 1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: $this,
                    start: 'top 80%',
                    end: 'bottom 20%',
                },
            })
        })
    },
    customLinkCircle() {
        $('.link-circle').each(function () {
            const marker = $(this)
            const svg = marker.find('svg')[0] // Access the raw DOM element, not a jQuery object
            const path = svg.querySelector('path') // Use querySelector to find the path in the SVG

            if (!path) {
                console.error('No path element found!')
                return
            }
            // Cache the path length for later use (avoid recalculating on every hover)
            const pathLength = path.getTotalLength()
            path.style.opacity = '0' // Initially hidden
            path.style.strokeDasharray = pathLength // Set to the length of the path
            path.style.strokeDashoffset = pathLength // Path is hidden at the start

            // Handle path drawing (start drawing on mouse hover)
            function setCircle(showElement) {
                if (showElement) {
                    path.style.opacity = '1' // Make path visible

                    path.style.strokeDashoffset = '0' // Animate drawing
                } else {
                    // Hide path when not hovered

                    path.style.strokeDashoffset = pathLength // Hide the path again
                }
            }

            // On mouse hover, show and animate the path
            marker.mouseover(() => {
                setCircle(true)
            })

            // On mouse out, hide the path
            marker.mouseout(() => {
                setCircle(false)
            })
        })
    },
    customParallx() {
        $('.pre-footer .bg-img.img img').each(function () {
            const $this = $(this)
            const sh = $(window).scrollTop()
            const parallaxH = $(this).offset().top
            const parallaxY = (sh - parallaxH) / 5
            const isSmallScreen = $(window).width() > 1024

            if (isSmallScreen) {
                $this.css('margin-top', parallaxY)
            } else {
                $this.css('margin-top', '0')
            }
        })
    },
    customDropdown() {
        $('.quicklinks .dropdown')
            .find('button')
            .on('click', function () {
                if ($(window).width() < 768) {
                    $(this).parents('.dropdown').toggleClass('is-active')
                    $(this).next('ul').slideToggle(200)
                    $('body').toggleClass('quicklinks-active')
                }
            })
        $('body').on('click', (e) => {
            const _con = $('.quicklinks .dropdown')
            if ($(window).width() < 768) {
                if (!_con.is(e.target) && _con.has(e.target).length === 0) {
                    _con.removeClass('is-active')
                    _con.find('ul').slideDown(200)
                    $('body').removeClass('quicklinks-active')
                }
            }
        })
    },
    customClick() {
        $('.form-input.select input, .form-input.filter input').click(function () {
            $(this).siblings('ul').stop().slideToggle(300)
                .parent()
                .addClass('active')
            $(this).parent().siblings().removeClass('active')
                .find('ul')
                .slideUp()
        })
        $('.form-input.select li, .form-input.filter li').click(function () {
            const text = $(this).text().trim()
            $(this).parent().slideUp()
            $(this).parent().siblings('input').val(text)
            $(this).parents('.form-input').removeClass('active')
        })
        $('.search-trigger').on('click', (e) => {
            e.preventDefault()
            $('.search-box').addClass('show-it')
            const sTime = setTimeout(() => {
                $('.search-popup').find('input').focus()
            }, 900)
        })

        $('#search-close').on('click', () => {
            $('.search-box').removeClass('show-it')
            $('.search-popup').find('input').blur()
        })

        $('body').on('click', (e) => {
            if (!$(e.target).closest('.search-box').length && !$(e.target).is('.search-trigger')) {
                $('.search-box').removeClass('show-it')
            }
        })

        $('.selection__title').on('click', function (e) {
            e.preventDefault()
            const me = $(this)
            const parent = me.closest('.selection')
            const parentSiblings = parent.siblings('.selection')
            me.toggleClass('is-open').siblings('.selection__dropdown').stop().slideToggle(250)
            parent.toggleClass('is-open')
            parentSiblings.removeClass('is-open')
            parentSiblings.find('.selection__title').removeClass('is-open')
            parentSiblings.find('.selection__dropdown').stop().slideUp(250)
        })

        $(document).on('click', (e) => {
            const container = $('.selection')
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.selection__dropdown').stop().slideUp(250)
                container.removeClass('is-open')
                container.find('.selection__title').removeClass('is-open')
            }
        })

        $('.business-listing .list .details-btn').on('click', function () {
            if ($(window).width() < 1024) {
                $(this).toggleClass('active')
                $(this).parent().siblings('.list--details').stop()
                    .slideToggle(300)
                $(this).parents('.list').siblings().find('.details-btn')
                    .removeClass('active')
                $(this).parents('.list').siblings().find('.list--details')
                    .slideUp()
            }
        })

        $('#happening').on('click', function () {
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active')
                $('.happening').removeClass('is-active')
                digistormWeb.unlockBg()
                digistormWeb.widgetUnlock()
            } else {
                $(this).addClass('is-active')
                $('.happening').addClass('is-active')
                digistormWeb.lockBg()
                digistormWeb.widgetLock()
            }
        })

        let $enterBool = 0
        $('.hoz-accordion .item').bind(' mouseenter ', function (e) {
            if ($(window).width() > 1023 && $enterBool === 0) {
                if (!$(this).hasClass('is-active')) {
                    $(this).addClass('is-active').siblings().removeClass('is-active')
                    $(this).parents('.items').addClass('is-active')
                }
            }
        })
        $('.hoz-accordion .item').on('click', function () {
            if (!$(this).hasClass('is-active')) {
                $(this).addClass('is-active').siblings().removeClass('is-active')
                $(this).parents('.items').addClass('is-active')
            }
        })
        $('.hoz-accordion .item svg:nth-child(2)').on('click', function (e) {
            e.stopPropagation()
            $enterBool = 1
            $(this).parents('.item.is-active').removeClass('is-active')
            $(this).parents('.items.is-active').removeClass('is-active')

            setTimeout(() => {
                $enterBool = 0
            }, 1000)
        })
    },
    customResize() {
        // const alertHeight = $('.alert-bar-active').length ? $('.alert-bar').innerHeight() : 0
        // const stickyHeight = $(window).height() - alertHeight
        $('body').attr(
            'style',
            `--height:${$(window).height()}px;`,
            // `--height:${$(window).height()}px; --sticky-height:${stickyHeight}px; --alert-height:${alertHeight}px`,
        )
    },
    customTabindexLoop() {
        const $menuItems = $('.left .navbar-logo .logo')
        const $socials = $('.offcanvas-navbar .socials').find('a')
        const $search = $('.left .search-trigger')
        let $focusableElements = $menuItems.add($socials)
        $focusableElements = $focusableElements.add($search)
        // Function to trap tab within the menu and burger button
        function trapTabKey(e) {
            let $firstFocusableElement
            const $lastFocusableElement = $focusableElements.last()
            if ($(window).width() >= 1024) {
                $firstFocusableElement = $focusableElements.first()
            } else {
                $firstFocusableElement = $focusableElements.eq(1)
            }

            // console.log($firstFocusableElement, $lastFocusableElement);
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    // Shift + Tab
                    if ($(document.activeElement).is($firstFocusableElement)) {
                        e.preventDefault()
                        $lastFocusableElement.focus()
                        // console.log("first");
                    }
                } else {
                    // Tab
                    if ($(document.activeElement).is($lastFocusableElement)) {
                        e.preventDefault()
                        $firstFocusableElement.focus()
                        // console.log("last");
                    }
                }
            }
        }

        // Add event listener to trap Tab key
        $(document).on('keydown', trapTabKey)
    },
    customModalOpen() {
        let flag = 0
        $('.open-video-modal').on('click', () => {
            if (!$('body').hasClass('video-modal-open')) {
                // digistormWeb.lockScroll()
                $('html').css('overflow', 'hidden')
                $('body').addClass('video-modal-open')
                flag++
            }
        })

        $('.search-trigger').on('click', () => {
            if (!$('body').hasClass('search-modal-open')) {
                $('body').addClass('search-modal-open')
                flag++
            }
        })
        $('.navbar-burger').on('click', () => {
            if (!$('body').hasClass('burger-modal-open')) {
                $('html').css('overflow', 'hidden')
                $('body').addClass('burger-modal-open')
                flag++
            } else {
                flag -= 1
                $('body').removeClass('burger-modal-open')
                if (flag === 0) {
                    // digistormWeb.unlockScroll()
                    $('html').css('overflow', '')
                }
            }
        })

        $('.video-modal .modal-background,.video-modal .close-button').on('click', () => {
            flag -= 1
            $('body').removeClass('video-modal-open')
            if (flag === 0) {
                // digistormWeb.unlockScroll()
                $('html').css('overflow', '')
            }
        })
        $('#search-close').on('click', () => {
            flag -= 1
            $('body').removeClass('search-modal-open')
        })
    },
    customAlertBar() {
        $('.alert-bar').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#page-container').addClass('alert-bar-active').css('margin-top', $('.alert-bar').height())
                // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", $(".alert-bar").height());

                $(window).on('resize', () => {
                    if ($('.alert-bar').hasClass('active')) {
                        $('#page-container').addClass('alert-bar-active').css('margin-top', $('.alert-bar').height())
                        // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", $(".alert-bar").height());
                    }
                })

                modal.find('.close-alert-bar').click(() => {
                    modal.addClass('delete')
                    $('#page-container').removeClass('alert-bar-active').css('margin-top', '0')
                    // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", "");
                    Cookies.set(key, 'viewed', {
                        expires: 5,
                    })
                    setTimeout(() => {
                        modal.removeClass('active')
                    }, 300)
                })
                modal.find('.alert-bar-background').click(() => {
                    modal.removeClass('active')
                })
            }
        })
    },
    customScroll() {
        const mainTop = $('#main').offset().top
        const scrollTop = $(window).scrollTop()

        if (scrollTop + 10 > mainTop) {
            $('body').addClass('enter-main')
        } else {
            $('body').removeClass('enter-main')
        }
    },
    customNewsBack() {
        $('.news-single-page .back-button').on('click', function (e) {
            e.preventDefault()
            const defaultLink = $(this).attr('data-default-link')
            if (document.referrer && document.referrer.indexOf(window.location.host) !== -1) {
                history.back()
            } else {
                window.location.href = defaultLink
            }
        })
    },
}

function initWebsiteScripts() {
    digistormWeb.init()
    customWeb.init()
}

// wait for vue to mount before attaching event listeners
// any event listeners attached before vue mounts will get deleted
document.addEventListener('ds-components-mounted', (e) => {
    initWebsiteScripts()
})

if (window.dsComponentsMounted) {
    initWebsiteScripts()
}

$(window).scroll(() => {
    customWeb.wowo()
    customWeb.customParallx()
    customWeb.customScroll()
})
$(window).on('load', () => {
    $('a.item button').attr('tabindex', '-1')
})
$(window).on('resize', () => {
    customWeb.customResize()
})
$(window).keydown((event) => {
    if (event.keyCode === 9) {
        $('.level1>li a').focus(function () {
            const me = $(this)
            me.parents('li').addClass('is-active')
            me.parents('li').siblings().removeClass('is-active')
            $('.level1').addClass('is-active')
        })
        $('.level1>li a').blur(function () {
            const me = $(this)
            if (me.parent('[class$=wrapper]').next().length === 0) {
                me.parents('li').removeClass('is-active')
                $('.level1').removeClass('is-active')
            }
        })
    }
})
